import React, { Component } from 'react';
import {
  IoMdHome,
  IoMdInformationCircle,
  IoIosApps,
  IoIosSunny,
  IoMdMoon,
} from 'react-icons/io';
import { Link } from 'react-scroll';
import { ReactComponent as WebDeveloper } from '../assets/webDeveloper.svg';

export class Header extends Component {
  onModeClick = () => {
    this.props.setDarkMode(!this.props.isDark);
  };

  render() {
    let dark = this.props.isDark ? 'dark' : '';

    return (
      <header className={`header ${dark}`}>
        <div className='navigation'>
          <a href='/' className='link logo'>
            <WebDeveloper className='icon' />
            <span>AP</span>
          </a>
          <ul className='nav'>
            <li className='nav__item'>
              <Link
                activeClass='active'
                to='home'
                spy={true}
                duration={100}
                className='link'
                onClick={this.onClose}
              >
                <IoMdHome className='icon icon-home' />
                <span className='nav__name'>Home</span>
              </Link>
            </li>
            <li className='nav__item'>
              <Link
                activeClass='active'
                to='about'
                spy={true}
                duration={100}
                offset={-50}
                className='link'
                onClick={this.onClose}
              >
                <IoMdInformationCircle className='icon icon-info' />
                <span className='nav__name'>About</span>
              </Link>
            </li>
            <li className='nav__item'>
              <Link
                activeClass='active'
                to='project'
                spy={true}
                duration={100}
                offset={-10}
                className='link'
                onClick={this.onClose}
              >
                <IoIosApps className='icon icon-info' />
                <span className='nav__name'>Projects</span>
              </Link>
            </li>
            <li className='nav__item' onClick={() => this.onModeClick()}>
              <span className='mode-toggle'>
                {this.props.isDark ? (
                  <IoIosSunny size='1.5em' color='currentColor' />
                ) : (
                  <IoMdMoon size='1.5em' color='currentColor' />
                )}
              </span>
            </li>
          </ul>
        </div>
      </header>
    );
  }
}

export default Header;
